/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const IntakeBinListService = {
  async save(payload) {
    const url = `api/Save_AlmondcoIntakeBinStockTransfer`;
    return await ApiService.post(url, payload);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { IntakeBinListService };
